'use strict';

(function () {
  'use strict';

  angular.module('msSleep').component('msSleepEntryForm', {
    templateUrl: 'sleep/templates/sleep-entry-form.html',
    controller: SleepEntryForm,
    controllerAs: 'vm',
    bindings: {
      /* <string> date in format YYYY-MM-DD */
      day: '<',
      /* <function>  a outbound function binding used to notify of completion.
                     If provided, it usurps the default navigation functionality
                     driving to the summary page.  To be used in Modals and other
                     non-navigation friendly scenarios.
      */
      onComplete: '&'
    }
  });
  SleepEntryForm.$inject = ['$state', '$log', 'sleepEntrySvc', 'dateTimeSvc', '$scope', 'focus'];

  /* @ngInject */
  function SleepEntryForm($state, $log, sleepEntrySvc, dateTimeSvc, $scope, focus) {
    var vm = this;
    vm.timeFormat = 'h:mm a';

    vm.$onInit = function () {
      $log.debug('SleepEntry activated');

      if (!vm.isValidDay()) {
        $state.go('vnext.content.sleep.main.diary');
      }

      focus.byId('sleepEntryFormHeading', 900);

      changeBodyClassList('add');
    };

    //this is triggered anytime the one-way bindings change (day or entry is updated)
    vm.$onChanges = function () {
      vm.currentDate = vm.day;
      vm.index = vm.visitedIndex = 0;
      vm.questions = 7;
      vm.answers = {};
      if (vm.isValidDay()) {
        sleepEntrySvc.getEntry(vm.day).then(function (data) {
          if (data) {
            populateFromEntry(data);
          } else {
            loadMru();
          }
        });
      }
    };

    vm.inBedChanged = function (val) {
      vm.answers.inBed = val;
      //pre-populate trySleep if empty
      if (!vm.answers.trySleep || vm.visitedIndex === 0) {
        vm.answers.trySleep = val;
      } else {
        validateTrySleepTime();
      }
    };

    vm.trySleepChanged = function (val) {
      vm.answers.trySleep = val;
      validateTrySleepTime();
    };

    vm.awakeChanged = function (val) {
      vm.answers.awake = val;
      if (!vm.answers.outOfBed || vm.visitedIndex < 5) {
        //pre-populate outOfBed if empty
        vm.answers.outOfBed = val;
      }
      var startTime = dateTimeSvc.getTimeAfterMinutesAdded(vm.answers.trySleep, vm.answers.minutesToSleep);
      var diff = dateTimeSvc.getHoursBetweenJavaTimes(startTime, vm.answers.awake);
      //make sure awake is not before going-to-sleep time, which you can tell if diff > 12
      vm.awakeError = diff < 1 || diff > 12;
    };

    vm.outOfBedChanged = function (val) {
      vm.answers.outOfBed = val;
      var diff = dateTimeSvc.getHoursBetweenJavaTimes(vm.answers.awake, vm.answers.outOfBed);
      //shouldn't be in bed more than 4 hours
      vm.outOfBedError = diff >= 4;
    };

    vm.saveEntry = function () {
      $log.debug('SleepEntry saveEntry. currentDate: ' + vm.currentDate);

      var request = buildRequest();
      sleepEntrySvc.save(request).then(function (data) {
        $log.debug('entry saved. entries: ');
        $log.debug(data);
        if (_.isFunction(vm.onComplete)) {
          vm.onComplete({
            day: vm.day,
            entryData: data.response,
            requirements: data.requirements
          });
        } else {
          $state.go('^.entry-summary', {
            day: vm.day,
            entryData: data.response,
            requirements: data.requirements
          });
        }
      });
    };

    vm.next = function (idx) {
      vm.index = idx;
      focus.byId('question' + ++idx, 900);

      if (vm.visitedIndex < vm.index) {
        vm.visitedIndex++;
      }
    };
    vm.isValidTime = function (prefix) {
      return vm.answers[prefix] && vm.answers[prefix].length > 0;
    };
    vm.isValidMinute = function (minute) {
      return angular.isNumber(minute);
    };

    vm.isValidDay = function () {
      return moment(vm.day, 'YYYY-MM-DD', true).isValid();
    };

    ////////////////
    function validateTrySleepTime() {
      var diff = dateTimeSvc.getHoursBetweenJavaTimes(vm.answers.inBed, vm.answers.trySleep);
      //shouldn't be in bed more than 6 hours trying to sleep
      vm.trySleepError = diff >= 6;
    }

    function populateFromEntry(entry) {
      $log.debug('populate from entry:', entry);
      vm.answers = entry;
      vm.answers.fullNight = vm.answers.fullNight.toString();
      vm.visitedIndex = 6;
    }

    function loadMru() {
      $log.debug('get most recent entry');
      sleepEntrySvc.getMostRecentEntry().then(function (data) {
        if (data && data.length) {
          //get default value from latest entry
          vm.answers.inBed = data[0].inBed;
          vm.answers.trySleep = data[0].inBed;
        }
      });
    }

    function buildRequest() {
      var request = {};
      if (vm.answers.id) {
        request.id = vm.answers.id;
      }

      request.day = vm.currentDate;
      request.sleepQuality = vm.answers.sleepQuality;
      request.fullNight = vm.answers.fullNight;
      request.minutesToSleep = vm.answers.minutesToSleep;
      if (vm.answers.fullNight === 'false') {
        request.minutesAwake = vm.answers.minutesAwake;
      } else {
        request.minutesAwake = 0;
      }
      request.inBed = vm.answers.inBed;
      request.trySleep = vm.answers.trySleep;
      request.awake = vm.answers.awake;
      request.outOfBed = vm.answers.outOfBed;
      return request;
    }

    function changeBodyClassList(action) {
      var bodyElement = angular.element(document.querySelector('body'));
      var bodyWithModal = bodyElement && bodyElement.find('#modalTarget > .modal-wrapper > .modal').attr('class');

      if (action === 'add' && bodyWithModal) {
        bodyElement.addClass('sleep-entry-dialog-open');
        return;
      }
      if (action === 'remove' && bodyElement.hasClass('sleep-entry-dialog-open')) {
        bodyElement.removeClass('sleep-entry-dialog-open');
      }
    }

    $scope.$on('$destroy', function () {
      changeBodyClassList('remove');
    });
  }
})();